/**
 * CMS Runtime Tailwind 全局 Store
 *
 * 跨实例共享，存储在 globalThis 上，SSR 和客户端都可访问。
 *
 * mergedCss 语义：
 *   null  — 尚未执行页面级合并编译（各组件可以独立编译）
 *   ''    — 已执行合并编译，但结果为空（页面无需 tailwind CSS）
 *   string — 合并编译的 CSS 内容，所有实例共享同一 <style> 块
 */

const CACHE_KEY = '__cms_runtime_tailwind_cache__'

// 检测 HTML 中是否含有需要 runtime Tailwind 处理的 class
const HINT_RE = /\b(?:sm:|md:|lg:|xl:|2xl:|hidden|block|inline|flex|grid|w-[\w\-/:[.\]%]+|h-[\w\-/:[.\]%]+|p[trblxy]?-[\w\-/:[.\]%]+|m[trblxy]?-[\w\-/:[.\]%]+|gap-[\w\-/:[.\]%]+|justify-[\w\-/:[.\]%]+|items-[\w\-/:[.\]%]+|text-[\w\-/:[.\]%]+|bg-[\w\-/:[.\]%]+|border-[\w\-/:[.\]%]+|rounded(?:-[\w\-/:[.\]%]+)?|shadow(?:-[\w\-/:[.\]%]+)?|opacity-[\w\-/:[.\]%]+|overflow-[\w\-/:[.\]%]+|truncate|min-w-[\w\-/:[.\]%]+|max-w-[\w\-/:[.\]%]+)\b/

export type RuntimeTailwindStore = {
  css: Map<string, string>
  pending: Map<string, Promise<string>>
  mergedCss: string | null
}

export const getRuntimeTailwindStore = (): RuntimeTailwindStore => {
  const g = globalThis as unknown as Record<string, unknown>
  const existed = g[CACHE_KEY] as RuntimeTailwindStore | undefined
  if (existed) return existed
  const created: RuntimeTailwindStore = { css: new Map(), pending: new Map(), mergedCss: null }
  g[CACHE_KEY] = created
  return created
}

export const shouldCompileRuntimeTailwind = (html: string): boolean => {
  if (!html) return false
  return HINT_RE.test(html)
}

/** 页面级合并编译的固定 style key */
export const MERGED_STYLE_KEY = 'cms-runtime-tailwind-merged'